import axiosInstance from '../axiosInterceptor/axiosInstance'

const createGroup = async ({ orgId, data }) => {
  const url = `v1/orgs/${orgId}/groups`
  const response = await axiosInstance.post(url, JSON.stringify(data))
  return response?.data
}

export default createGroup
